import axios from "axios";

export type UserPoolId = 'Main' | 'PWA' | 'None';

export interface PoolCheck {
  IsConfirmed: boolean;
  UserPool: UserPoolId;
}

/*
 * This functions calls the '/cognitouser/poolcheck' endpoint.
 * Which verifies the users user pool and email verification status
 * @param {string} email - The users email.
 * @returns {object} - Returns the object which implements the PoolCheck interface
 */
export const poolCheck = async (email: string) => {
  // POST to the auth-proxy Lambda we exposed at /api/amz/cognitouser/poolcheck
  const response = await axios.post(
    `${process.env.REACT_APP_SECURE_API_GATEWAY}/api/amz/cognitouser/poolcheck`,
    { EmailAddress: email }
  );

  if (response?.data?.userPool === 'Main' || response?.data?.userPool === 'PWA') {
    response.data.UserPool ??= response.data.userPool;
    response.data.IsConfirmed ??= true;
  }

  return response.data as PoolCheck;
}
